import { render, staticRenderFns } from "./form-paragraph-submitted-preview.vue?vue&type=template&id=5239a7be&"
import script from "./form-paragraph-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./form-paragraph-submitted-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-paragraph-submitted-preview.vue"
export default component.exports